export const TEXTO_FEATURE_FLAGS = {
  DESCARGA_MASIVA: 'DescargaMasiva',
  REALIZAR_PAGOS_PORTAL_CLIENTE: 'RealizarPagosPortalCliente',
  ACTIVAR_GENERAR_REPORTE_DEL_MOVIMIENTO: 'ActivarGenerarReporteDelMovimiento',
  HABILITAR_RETENCIONES_PORTAL_CLIENTE: 'HabilitarRetencionesPortalCliente',
}
